import { Routes } from '@angular/router';
import { ShellComponent } from './shell/shell.component';
import { initialize, loggedIn, notFound, profileLoaded, workstationSelected } from '@app/core/guards';
import { provideAuthStore } from '@app/store/auth';
import { provideCartonsStore } from '@app/store/cartons';
import { provideDeviceStore } from '@app/store/device';
import { providePalletsStore } from '@app/store/pallets';
import { providePlacedBoxesStore } from '@app/store/placed-boxes';
import { provideProfileStore } from '@app/store/profile';
import { provideScannerStore } from '@app/store/scanner';
import { provideSortingStore } from '@app/store/sorting';
import { provideUnassignedBoxesStore } from '@app/store/unassigned-boxes';
import { provideUpdateStore } from '@app/store/update';
import { provideWorkstationStore } from '@app/store/workstation';

export const appRoutes: Routes = [
    {
        path: '',
        redirectTo: initialize(),
        pathMatch: 'full',
    },
    {
        path: 'auth',
        providers: [...provideAuthStore()],
        loadChildren: () => import('./auth/auth.routing').then(({ routes }) => routes),
    },
    {
        path: '',
        canActivate: [loggedIn(), profileLoaded()],
        component: ShellComponent,
        providers: [
            ...provideProfileStore(),
            ...provideWorkstationStore(),
            ...provideAuthStore(),
            ...provideDeviceStore(),
            ...provideScannerStore(),
            ...providePlacedBoxesStore(),
            ...provideUnassignedBoxesStore(),
            ...provideCartonsStore(),
            ...providePalletsStore(),
            ...provideSortingStore(),
            ...provideUpdateStore(),
        ],
        children: [
            {
                path: 'workstation',
                loadChildren: () => import('./workstation/workstation.routing').then(({ routes }) => routes),
            },
            {
                path: 'mode',
                canActivate: [workstationSelected()],
                loadChildren: () => import('./mode/mode.routing').then(({ routes }) => routes),
            },
            {
                path: '**',
                redirectTo: notFound(),
            },
        ],
    },
];
